import MessageTemplateContainer from './MessageTemplateContainer';
export default MessageTemplateContainer;
